export const FORM_FIELDS_NAMES = {
    SELECT_DOCUMENT_TYPE: 'documentTypeId',
    DATE: 'date',
    DOCUMENT_NAME: 'documentName',
    UPLOAD_FILE: 'file',
    TYPE_NAME: 'typeName'
}